var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Icon - Seach",
    viewBox: "-0.5 -0.5 25.5 25.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#737c81",
    d: "M0 0h24.5v24.5H0z",
    "data-name": "Rectangle 417"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#icon-search_svg__a)",
    "data-name": "Group 966"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    "data-name": "Ellipse 155",
    transform: "translate(.75 .75)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.687 14.535l9.063 9.215",
    "data-name": "Line 346"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iSWNvbiAtIFNlYWNoIiB2aWV3Qm94PSItMC41IC0wLjUgMjUuNSAyNS41Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzczN2M4MSIgZD0iTTAgMGgyNC41djI0LjVIMHoiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDQxNyIvPjwvY2xpcFBhdGg+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzczN2M4MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuNSIgY2xpcC1wYXRoPSJ1cmwoI2EpIiBkYXRhLW5hbWU9Ikdyb3VwIDk2NiI+PGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGRhdGEtbmFtZT0iRWxsaXBzZSAxNTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC43NSAuNzUpIi8+PHBhdGggZD0ibTE0LjY4NyAxNC41MzUgOS4wNjMgOS4yMTUiIGRhdGEtbmFtZT0iTGluZSAzNDYiLz48L2c+PC9zdmc+";
export { SvgIconSearch as ReactComponent };